const selectors = {
  container: "render-sections-container",
};

export default selectors;
